import { useState, useEffect } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";
import { useLocation, useNavigate ,Link } from "react-router-dom";
import { toast } from "react-toastify";
import BuilderService from "../../services/BuilderService";
import { Loader } from  './Loader'
import { useTheme } from '../../../redux/hooks/useTheme';
import { motion, Variants } from 'motion/react';
import Logo from '../Dashboard/SubComponents/Logo';

import ReCAPTCHAComponent from "../../utils/ReCAPTCHA"
export default function CreatePassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email, setEmail] = useState<string | null>(null);
  const [isChecking, setIsChecking] = useState<boolean>(false);   const { theme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const builderService = new BuilderService();

  // Password validation checks
  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
  const hasMinLength = password.length >= 8;

const handleCreateAccount = async () => {
  if (!email) return;

  if (password !== confirmPassword) {
    toast.error('Passwords do not match');
    return;
  }

  if (hasLowercase && hasUppercase && hasNumber && hasSpecial && hasMinLength) {
    try {
      setIsChecking(true);
      const response = await builderService.createUser({
        email,
        password
      });

      if (response.success) {
        toast.success('Account created successfully!');
        navigate('/');
      } else {
        toast.error(response.message || 'Failed to create account');
      }
    } catch (error) {
      toast.error('Failed to create account');
    } finally {
      setIsChecking(false);
    }
  } else {
    toast.error('Please ensure all password requirements are met');
  }
};

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (hasLowercase && hasUppercase && hasNumber && hasSpecial && hasMinLength && !isChecking) {
        handleCreateAccount();
      }
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    // if (!emailParam) {
    //   toast.error('Email not found');
    //   navigate('/signup');
    //   return;
    // }
    setEmail(emailParam);
    params.delete('email');
    const newUrl = window.location.pathname + 
      (params.toString() ? `?${params.toString()}` : '');
    window.history.replaceState({}, document.title, newUrl);
  }, [navigate, location.search]);

  return (
    <div 
    style={{
      background: `url(${theme.heroSectionImage}) no-repeat`,
      backgroundColor: theme.heroSectionBackgroundGradient,
    }}
    className="flex items-center justify-center min-h-screen bg-gray-50">
    <ReCAPTCHAComponent/>
   <div className="flex flex-col justify-center items-center gap-[40px] create-mb-p">
                    <motion.div
                      className="flex  items-center w-[132px] sm:w-auto logo-mob"
                    >
                      <Link to="/">
                      {/* <img
                        src={theme.heroLogo} // Use src instead of background
                        className="h-10 mr-2 md:p-0"
                        alt="Advance To Builder"
                      />   */}
                      <Logo />

                      </Link>
                    </motion.div>
      <div className="sign-up-upr">
<div
  className="w-full max-w-[480px] rounded-[20px] bg-white p-[18px] sm:p-[32px] md:p-[40px] signup-p"
  style={{ width: '100%' }}
>
        <div className="flex justify-center mb-6">
          <div className="">
            <span>
              <img src="https://dlvkyia8i4zmz.cloudfront.net/QqXiz7ffTYaG9WpMcVh8_Frame__10_.svg" />
            </span>
          </div>
        </div>

        <p style={{ color: theme.mainHeadingOne, fontWeight:600 }} className="text-[26px] flex item-center justify-center font-sora mb-[10px]">Create Your Password</p>
        <p style={{fontWeight:400, textAlign:'center'}} className="text-[16px] flex item-center justify-center signup-hm mb-[24px] font-inter">
          Set a strong and secure password to complete your account setup.
        </p>

        {/* Password input */}
        <div className="relative mb-4">
          <div className="flex items-center sp-border rounded-[12px] overflow-hidden">
          <div className="absolute inset-y-0 p-[14px] flex items-center spborder-r">
         <span style={{color:theme.seIcon}} className="w-[18px] h-[18px]">
        
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.7499 15.375H5.24994C2.99994 15.375 1.49994 14.25 1.49994 11.625V6.375C1.49994 3.75 2.99994 2.625 5.24994 2.625H12.7499C14.9999 2.625 16.4999 3.75 16.4999 6.375V11.625C16.4999 14.25 14.9999 15.375 12.7499 15.375Z"  stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.7501 6.75L10.4026 8.625C9.63006 9.24 8.36256 9.24 7.59006 8.625L5.25006 6.75"  stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

         </span>
            </div>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full signout-h create-pass rounded-[12px] py-[14px] pl-[55px] pr-4 focus:outline-none"
              placeholder="Password"
            />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="pr-4">
              {showPassword ?  <Eye style={{color:theme.seIcon}} className="w-5 h-5 text-gray-500" />:<EyeOff style={{color:theme.seIcon}} className="w-5 h-5 text-gray-500" /> }
            </button>
          </div>
        </div>

        {/* Password requirements */}
        <div className="grid grid-cols-2 mt-[10px] gap-2 mb-[18px]">
          <div className="flex items-center gap-2">
            <div
              className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasLowercase ? " text-green-600" : " text-gray-400"}`}
            >
              <CheckIcon checked={hasLowercase} />
            </div>
            <span style={{fontWeight:400, textAlign:'center' }} className="s-suggestion font-inter text-[12px] mob-text">One lowercase character</span>
          </div>
          <div className="flex items-center gap-2">
            <div
              className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasSpecial ? " text-green-600" : " text-gray-400"}`}
            >
              <CheckIcon checked={hasSpecial} />
            </div>
            <span style={{fontWeight:400, textAlign:'center' }} className="s-suggestion font-inter text-[12px] mob-text">One special character</span>
          </div>
          <div className="flex items-center gap-2">
            <div
              className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasUppercase ? " text-green-600" : " text-gray-400"}`}
            >
             <CheckIcon checked={hasUppercase} />
            </div>
            <span style={{fontWeight:400, textAlign:'center' }} className="s-suggestion font-inter text-[12px] mob-text">One uppercase character</span>
          </div>
          <div className="flex items-center gap-2">
            <div
              className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasMinLength ? " text-green-600" : " text-gray-400"}`}
            >
             <CheckIcon checked={hasMinLength} />
            </div>
            <span style={{fontWeight:400, textAlign:'center' }} className="s-suggestion font-inter text-[12px] mob-text">Min 8 characters</span>
          </div>
          <div className="flex items-center gap-2">
            <div
              className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasNumber ? " text-green-600" : " text-gray-400"}`}
            >
             <CheckIcon checked={hasNumber} />
            </div>
            <span style={{fontWeight:400, textAlign:'center' }} className="s-suggestion font-inter text-[12px] mob-text">One number</span>
          </div>
        </div>

        {/* Confirm password input */}
        <div className="relative mb-8">
          <div className="flex items-center sp-border rounded-[12px] overflow-hidden">
          <div className="absolute inset-y-0 p-[14px] flex items-center spborder-r">
          
          <span style={{color:theme.seIcon}} className="h-[18px] w-[18px]">
         
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 7.5V6C4.5 3.5175 5.25 1.5 9 1.5C12.75 1.5 13.5 3.5175 13.5 6V7.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 13.875C10.0355 13.875 10.875 13.0355 10.875 12C10.875 10.9645 10.0355 10.125 9 10.125C7.96447 10.125 7.125 10.9645 7.125 12C7.125 13.0355 7.96447 13.875 9 13.875Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.75 16.5H5.25C2.25 16.5 1.5 15.75 1.5 12.75V11.25C1.5 8.25 2.25 7.5 5.25 7.5H12.75C15.75 7.5 16.5 8.25 16.5 11.25V12.75C16.5 15.75 15.75 16.5 12.75 16.5Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>  
          </span>

           </div>
            <input
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              className="w-full signout-h create-pass  rounded-[12px] py-[14px] pl-[55px] pr-4 focus:outline-none"
              placeholder="Confirm password"
            />
            <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{color:theme.seIcon}} className="pr-4">
              {showConfirmPassword ? (
               
                <Eye style={{color:theme.seIcon}} className="w-5 h-5" />
              ) : (
                 <EyeOff style={{color:theme.seIcon}} className="w-5 h-5 " />
              )}
            </button>
          </div>
        </div>

        {/* Continue button */}
        <button 
        style={{height:'45px'}}
          className="w-full py-[14px] text-white font-inter h-[45px] sign-upbt rounded-[12px] transition-colors"
          onClick={handleCreateAccount } 
          disabled={
            !hasLowercase || !hasUppercase || !hasNumber || !hasSpecial || !hasMinLength || isChecking
          }
            >
          {isChecking ? <Loader text="Loading..." /> : "Continue"}
        </button>
      </div>
      </div>
   </div>
    </div>
  );
}

// Custom check icon component
function CheckIcon({ checked }: { checked: boolean }) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke={ checked  ? "#00875a" : "#666666"} // Green if checked, gray if not
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9 12l2 2 4-4" />
  </svg>
  );
}